<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qKJYnN/images/9781439663394.jpg?1684515197871" alt="This image is the cover for the book Cycling in Chicago, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cycling in Chicago, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>In the late 19th and early 20th century, Chicago was the center of bicycle manufacturing in the United States. As an early industrial and transportation center, two-thirds of all bicycles manufactured in the United States were from Chicago--it was the Detroit of bike manufacturing. For decades, Chicago was also a center for cycling track and road racing. Six-day races drew capacity crowds at the Chicago Stadium, Chicago Coliseum, and International Amphitheatre.  Road and track competitions were also held at Sherman Park, the Humboldt Park Velodrome, and on Chicago's famed Magnificent Mile. Today, Chicago is a hub for recreational cyclists. Hundreds of miles of bike lanes, rail to trails, and bike paths, such as the Illinois Prairie Path, the Bloomingdale Trail, Lakefront Path, and the Big Marsh, provide cyclists with numerous recreational and commuting options in a crowded urban environment. Chicago was awarded Bicycling Magazine's Best Bike City of 2016.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris McAuliffe
      </h2>
      
      <p class="authorDescription body article">Chris McAuliffe is a longtime Chicago-area cyclist who competes in road and cyclocross racing. Chris holds a USA Cycling racing license and races for the XXX Racing-Athletico cycling team. He also enjoys recreational cycling and exploring the many bike trails and forest preserves around Chicagoland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b5d6022